import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import {
 Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { toast } from "sonner";

function todayISO() {
 const d = new Date();
 const pad = (n) =>String(n).padStart(2, "0");
 return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

const EMPTY = {
 description: "", category: "", amount: 0, date: todayISO(), notes: "",
 is_recurring: false, recurring_day: null,
};

export default function ExpenseFormDialog({ open, onOpenChange, expense, onSaved, suggestions = [] }) {
 const [form, setForm] = useState(EMPTY);
 const [saving, setSaving] = useState(false);

 useEffect(() =>{
 if (expense) setForm({ ...EMPTY, ...expense, recurring_day: expense.recurring_day ?? null });
 else setForm({ ...EMPTY, date: todayISO() });
 }, [expense, open]);

 const set = (k) =>(e) =>setForm((f) =>({ ...f, [k]: e.target.value }));

 const submit = async (e) =>{
 e.preventDefault();
 if (form.is_recurring && (!form.recurring_day || form.recurring_day< 1 || form.recurring_day >31)) {
 toast.error("Informe o dia do mês (1 a 31)");
 return;
 }
 setSaving(true);
 try {
 const payload = {
 ...form,
 amount: Number(form.amount) || 0,
 recurring_day: form.is_recurring ? Number(form.recurring_day) : null,
 };
 if (expense?.expense_id) {
 await api.put(`/expenses/${expense.expense_id}`, payload);
 toast.success("Gasto atualizado ");
 } else {
 await api.post("/expenses", payload);
 toast.success("Gasto registrado ");
 }
 onSaved?.();
 } catch (err) {
 toast.error(formatApiError(err.response?.data?.detail));
 } finally {
 setSaving(false);
 }
 };

 return (<Dialog open={open} onOpenChange={onOpenChange}><DialogContent className="max-w-md" data-testid="expense-form-dialog"><DialogHeader><DialogTitle>{expense ? "Editar gasto" : "Novo gasto"}</DialogTitle><DialogDescription>Registre contabilidade, impostos, investimentos ou qualquer despesa.</DialogDescription></DialogHeader><form onSubmit={submit} className="space-y-3"><div><Label>Descrição</Label><Input required value={form.description} onChange={set("description")}
 placeholder="Honorários do contador" data-testid="expense-form-description" /></div><div className="grid grid-cols-2 gap-3"><div><Label>Categoria</Label><Input required value={form.category} onChange={set("category")}
 placeholder="Contabilidade" list="expense-categories"
 data-testid="expense-form-category" /><datalist id="expense-categories">{suggestions.map((s) =><option key={s} value={s} />)}</datalist></div><div><Label>Valor (R$)</Label><Input type="number" step="0.01" min="0.01" required value={form.amount}
 onChange={set("amount")} data-testid="expense-form-amount" /></div></div><div><Label>{form.is_recurring ? "Data de início" : "Data"}</Label><Input type="date" required value={form.date} onChange={set("date")}
 data-testid="expense-form-date" /></div><label htmlFor="exp-rec-toggle"
 className="flex items-center gap-2 cursor-pointer pt-1 pb-0.5 text-sm"><Checkbox id="exp-rec-toggle"
 checked={form.is_recurring}
 onCheckedChange={(v) =>setForm((f) =>({
 ...f,
 is_recurring: !!v,
 recurring_day: v ? (f.recurring_day || (new Date(f.date || todayISO()).getDate())) : null,
 }))}
 data-testid="expense-form-recurring-toggle" /><span className="font-medium text-slate-700">Gasto recorrente mensal</span></label>{form.is_recurring && (<div className="rounded-lg border border-blue-100 bg-blue-50/40 p-3"
 data-testid="expense-form-recurring-fields"><Label className="text-xs">Dia do mês (1–31)</Label><Input type="number" min="1" max="31" required
 value={form.recurring_day ?? ""}
 onChange={(e) =>setForm((f) =>({ ...f, recurring_day: e.target.value ? Number(e.target.value) : null }))}
 placeholder="Ex: 5"
 data-testid="expense-form-recurring-day" /><p className="text-xs text-slate-500 mt-1">Este gasto será contabilizado todo mês a partir da data de início.</p></div>)}<div><Label>Observações</Label><Textarea rows={2} value={form.notes || ""} onChange={set("notes")}
 data-testid="expense-form-notes" /></div><DialogFooter><Button type="button" variant="outline" onClick={() =>onOpenChange(false)}>Cancelar</Button><Button type="submit" disabled={saving} className="brand-grad text-white"
 data-testid="expense-form-submit">{saving ? "Salvando..." : "Salvar"}</Button></DialogFooter></form></DialogContent></Dialog>);
}
